import React from 'react';
import '../styles/MyDrawingSection.css';
import Drawing from './Drawing';
function MyDrawingSection(props) {
    const title = "Beautiful green city with a monkey on tree";
    const submittedBy = "Prakash";
    return (
        <div>
            <h2>My Drawings and Arts</h2>
            <div className="gallary">
                <Drawing title={title} submittedBy={submittedBy}/>
                <Drawing title={title} submittedBy={submittedBy}/>
                <Drawing title={title} submittedBy={submittedBy}/>
                <Drawing title={title} submittedBy={submittedBy}/>
                <Drawing title={title} submittedBy={submittedBy}/>
                <Drawing title={title} submittedBy={submittedBy}/>
                <Drawing title={title} submittedBy={submittedBy}/>
                <Drawing title={title} submittedBy={submittedBy}/>
            </div>
        </div>
    );
}

export default MyDrawingSection;